import { Vendor } from './vendor.model';
import { SessionMap } from './session-map.model';

export class CourseVendor {
    id:number;
    status:string;
    joinUrl:string;
    docebo:{id:number, showOpen:boolean, status:boolean};
    zoom:{id:number, showOpen:boolean, status:boolean};
    vendor:Vendor;
    sortOrder: number;
    videoUrl: string;
    
    constructor(data){
        this.id = data.id ? data.id : null;
        this.status = data.status ? data.status : null;
        this.vendor = (data.casce_vendor) ? new Vendor(data.casce_vendor) : new Vendor({});
        this.joinUrl = data.join_url ? data.join_url : null;
        let docebo = (data.docebo) ? JSON.parse(data.docebo) : null;
        this.docebo = (docebo && docebo.id && docebo.status) ? {id:docebo.id, showOpen:docebo.show_open, status: true} : {id: null, showOpen: false, status: false};
        let zoom = (data.zoom) ? JSON.parse(data.zoom) : null;
        this.zoom = (zoom && zoom.id && zoom.status) ? {id:zoom.id, showOpen:zoom.show_open, status: true} : {id: null, showOpen: false, status: false};
        this.sortOrder = data.sort_order ? parseInt(data.sort_order) : null;
        this.videoUrl = data.video_url ? data.video_url : null;
    }
}
